import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import { setPromoCodeId } from './affiliate-promo-code.actions';

export interface AffiliatePromoCodeState {
  promoCodeId?: string;
  promoCodeAmount?: number;
}

/**
 * DEBT: these promo codes are currently hardcoded (as with similar affiliate/partner integrations) and will be moved when the PoC has positive results.
 * @see https://jira.essent.nl/jira/browse/CTR-1877
 * @param promoCodeId
 * @returns
 */
function mapStateFromPromoCodeId(
  promoCodeId: string | null
): AffiliatePromoCodeState {
  let state: AffiliatePromoCodeState = {};

  if (promoCodeId === '1234ABC') {
    state = {
      promoCodeId,
      promoCodeAmount: 30,
    };
  }

  return state;
}

const _reducer = createReducer(
  {},
  on(setPromoCodeId, (_, { promoCodeId }) =>
    mapStateFromPromoCodeId(promoCodeId)
  )
);

export function affiliatePromoCodeReducer(
  state: AffiliatePromoCodeState = {},
  action: Action
) {
  return _reducer(state, action);
}
